import { stub_gpp_usnat } from './stub_gpp_usnat.js';
import { stub_tcfv2 } from './stub_tcfv2.js';
import { stub_uspapi_ccpa } from './stub_uspapi_ccpa.js';

const stub = (framework) => {
  switch (framework) {
    case "tcfv2":
      stub_tcfv2();
      break;
    case "usnat":
      stub_gpp_usnat();
      stub_uspapi_ccpa();
      break;
    case "aus":
      stub_uspapi_ccpa();
      break;
  }
};

export { stub };
